import { Icon, Tooltip } from '@branchjs/neo-components';
import { useDraggableMultiValueService } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/hooks';
import type { IndexedOption, MultiValueProps } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';
import clsx from 'clsx';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { components } from 'react-select';

const DraggableMultiValue = (props: MultiValueProps<IndexedOption>) => {
  const { css, innerProps, disabled } = useDraggableMultiValueService(props);

  const draggableElement = (
    <Draggable key={props.data.value} draggableId={props.data.value} index={props.data.index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={clsx(css.label, disabled ? 'DraggableMultiValue-disabled' : 'DraggableMultiValue-enabled')}
        >
          <components.MultiValue {...props} innerProps={innerProps} />
        </div>
      )}
    </Draggable>
  );

  const title = (
    <div className={css.title}>
      <Icon className={css.icon} color="warning">
        warning
      </Icon>
      The max limit for the compare-by filter is four when table type is set to drill-down table. Re-arrange the first four
      or alternatively switch to flat table type to increase the limit.
    </div>
  );

  if (!disabled) {
    return draggableElement;
  }

  return (
    <Tooltip id={`draggable-multi-value-tooltip-${props.data.value}`} title={title} placement="bottom-start">
      <div>{draggableElement}</div>
    </Tooltip>
  );
};

export default DraggableMultiValue;
